import { Button } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import SingleSelectButtonGroup from '../common/SingleSelectButtonGroup';



const defaultButtonTitleValues = [
    {title:'Yes',value:true},
    {title:'No',value:false}
];



const Container = styled.div`
  display:flex;
  justify-content: space-between;
  text-align:center;
  align-items:center;
`;

function isDisabled(formProps, index, value) {
    let retValue = false;
    if (formProps) {
        formProps.values.workflowSteps.forEach((workflowStep, stepIndex) => {
            if (index === 0 && value === 'CORP') {
                retValue = true;
            }

            if (stepIndex === 0 && index === 0 && (value === 'PROJECT' || value === 'GBU')) {
                retValue = false;
            }
            
            if (stepIndex > 0 && index > 0 && value === 'PROJECT') {
                if (formProps.values.workflowSteps[stepIndex - 1].stepScope === 'GBU' || formProps.values.workflowSteps[stepIndex - 1].stepScope === 'CORP' ) {
                    retValue = true;
                } else {
                    retValue = false;
                }
            }
            
            if (stepIndex > 0 && index > 0 && value === 'GBU') {
                if (formProps.values.workflowSteps[stepIndex - 1].stepScope === 'CORP' ) {
                    retValue = true;
                } else {
                    retValue = false;
                }
            }

            if (index > 0 && formProps.values.workflowSteps[index - 1].stepScope === 'PROJECT') {
                retValue = false;
            }
            if (index === 0 && value === 'PROJECT') {
                retValue = false;
            }

            
            if (index > 0 && formProps.values.workflowSteps[index - 1].stepScope === 'GBU') {
                retValue =  value === 'PROJECT' ? true : false;
            } 

            if (index > 0 && formProps.values.workflowSteps[index - 1].stepScope === 'CORP') {
                retValue =  (value === 'PROJECT' || value === 'GBU') ? true : false;
            }   
        });
    }
    return retValue;
}

const FormikButtonsQuestion = ({index,formProps,value,setFieldValue,setFieldTouched,field,buttonTitleValues=defaultButtonTitleValues,onValueChanged,pillStyling=false}) => {
  
    let buttons = buttonTitleValues.map(titleValue => 
        <Button variant="outlined" key={titleValue.value} value={titleValue.value} disabled={isDisabled(formProps, index, titleValue.value)}>{titleValue.title}</Button>
    );

    return(
        <Container>
            <SingleSelectButtonGroup
                pillStyling
                value={value} 
                onValueChanged={value=>{
                    const pos = field.indexOf('.');
                    const valueIndex = Number(field.substring(pos+1,pos+2));
                    isDisabled(formProps,valueIndex,value);
                    setFieldValue(field,value);
                    setFieldTouched(field);

                    if ( onValueChanged ) {
                        onValueChanged(value);
                    }
                }}
            >
            {buttons}
            </SingleSelectButtonGroup>
        </Container>
            
    );
  }

  export default FormikButtonsQuestion;
